export { LogErrors } from './log-errors';
export { LogRequests } from './log-requests';
export { corsPlugin } from './cors';
export { dedupeGraphQL } from './graphql-deduplicator';

export type { CorsPluginOptions } from './cors';
